import { React } from 'react';
import { Container, Stack } from 'react-bootstrap';
import { UsersList } from './UsersList/UsersList';
import { useTranslation } from 'react-i18next';
export function UserManagement() {
    const { t } = useTranslation();
    return (
        <Container fluid className="px-5" style={{ maxWidth: '1280px' }}>
            <Stack direction="horizontal" gap={3} className="mt-4 justify-content-between">
                <h2>{t('usManagement')}</h2>
            </Stack>
            <UsersList />
        </Container>
    );
}